import { Component, Input, OnInit } from '@angular/core';

import { AuthService } from '../../../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';
import { FillBatchReportService } from '../../../../services/fill-batch-report.service';
import { CheckUserType } from '../../../../models/checkUserType';
import { ColumnService } from '../../../../services/ColumnService';
import { saveAs as importedSaveAs } from 'file-saver';

@Component({
  selector: 'app-fill-batch-cyl',
  templateUrl: './fill-batch-cyl.component.html',
  styleUrls: ['./fill-batch-cyl.component.css']
})
export class FillBatchCylComponent implements OnInit {
  @Input() fill_Batch_Id: number;

  modalService: ModalService;
  role = new CheckUserType();
  client;

  filter: any = {
    quick_Search: ""
  };

  headlineDetails = Array<any>();

  reject: boolean = false;
  cylinder_Id: string;
  cylinder_Serial_No: string;
  showHistoryEmbedded: boolean = false;
  showEditBatch: boolean = false;

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  availableOptions: string[] = [
    'Cylinder_ID',
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'Refilled',
    'Last Fill Batch Num',
    'In Service',
    'Customer Name',
    'Acc #',
    'Address 1',
    'Post Code',
    'Valve Serial #',
    'Valve Model #',
    'Owner',
    'RFID Tag',
    'Cyl Manuf Date',
    'Cyl EOL Date',
    'Cyl Test Date',
    'Valve Manuf Date',
    'Valve EOL Date',
    'Valve Test Date',
    'Last Fill Date',
    'Last Fill Expiry Date'
];


  selectedOptions: string[] = [
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'Refilled',
    'In Service',
    'Customer Name',
    'Owner',
    'RFID Tag'
  ];

  constructor(authService: AuthService, public fillBatchReportService: FillBatchReportService, modalService: ModalService,
    public router: Router, private route: ActivatedRoute, private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    this.modalService = modalService;

  }

  ngOnInit() {
    this.getcolumns();
    if (this.fill_Batch_Id != undefined) {
      this.reject = false;
      this.loadTable();
      this.loadHeadlineDetails();
      this.init = true;
    }
    else {
      this.fill_Batch_Id = this.route.snapshot.queryParams.fill_Batch_Id;
      this.reject = this.route.snapshot.queryParams.reject;

      this.loadTable();
      this.loadHeadlineDetails();
      this.init = true;
    }

  }

  openEditBatchPopup() {
    this.showEditBatch = true;

    this.modalService.open('popup-edit-batch');
  }

  closeEditBatchPopup() {
    this.showEditBatch = false;
    this.modalService.close('popup-edit-batch');
  }

  openCylHistory(row) {
    this.showHistoryEmbedded = true;

    this.cylinder_Id = row.cylinder_ID;
    this.cylinder_Serial_No = row.cyl_Serial_Num;

    this.modalService.open('popup-cyl-history-embedded');
  }

  closeCylHistory() {
    this.showHistoryEmbedded = false;

    this.modalService.close('popup-cyl-history-embedded');
  }

  // ###################################
  // TABLE                              
  // ###################################
  setPage(pageInfo) { 
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(); 
  }                   

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable();
  }

  loadTable() {
    this.fillBatchReportService.getBatchCylResults(this.page, this.fill_Batch_Id, this.reject, this.filter.quick_Search).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  loadHeadlineDetails() {
    this.fillBatchReportService.getHeadlineDetails(this.fill_Batch_Id).then((details) => {
      const dateStart = moment(details[0].startTime, "YYYY-MM-DDTHH:mm:ss");
      const dateFinish = moment(details[0].finishTime, "YYYY-MM-DDTHH:mm:ss");
      const fill_Date = moment(details[0].fill_Date, "YYYY-MM-DD");
      const expiry_Date = moment(details[0].expiry_Date, "YYYY-MM-DD");
      details[0].textDateStart = dateStart.format("DD MMMM YYYY");
      details[0].startTime = dateStart.format("h:mm A"); 
      details[0].textDateFinish = dateFinish.format("DD MMMM YYYY");
      details[0].finishTime = dateFinish.format("h:mm A");
      details[0].fill_Date = fill_Date.format("DD MMMM YYYY");;
      details[0].expiry_Date = expiry_Date.format("DD MMMM YYYY");;

      this.headlineDetails = details[0];

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable();
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "fillBatchCylinder").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "fillBatchCylinder", this.selectedOptions).then((data) => {
    });
  }

  generateExcel() {
      this.fillBatchReportService.getBatchCylExcel(this.page, this.fill_Batch_Id, this.reject, this.filter.quick_Search).then((data) => {
        importedSaveAs(data, 'Fill_Batch_Cylinders.xlsx');
      });
    }
}
